const namespaced = true

const state = {
  list: [],
  list_loaded: false,
}

const getters = {
  list: (state) => state.list,
  list_loaded: (state) => state.list_loaded,
}

const mutations = {
  index: (state, payload) => {
    state.list_loaded = true
    state.list = payload.length ? payload : []
  },
}

const actions = {
  index: ({ commit }) => {
    axios.get('/api/favorites/').then(({ data }) => {
      commit('index', data)
      return data
    })
  },
  store: ({ commit }, payload) => {
    console.log(payload)
    axios.put('/api/favorites/', payload).then(({ data }) => {
      commit('index', data)
    })
  },
}

export default {
  mutations,
  actions,
  state,
  getters,
  namespaced,
}
